/**
 * @file: description
 * @author: dongjing
 * @Date: 2020-03-13 19:58:27
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-07-08 22:22:55
 */
import React, { useEffect, useRef, useState } from 'react';
//@ts-ignore
import VditorPreview from 'vditor/dist/method.min.js';
import './SFCReadVditor.less';
import SFCCatelog from './SFCCatelog';

const xss = require('xss');

export interface ISFCReadVditorProps {
  content?: string;
}
type Props = ISFCReadVditorProps;
export function SFCReadVditor(props: Readonly<Props>) {
  const { content = '' } = props;
  const editCon = useRef<HTMLDivElement>(null);
  const [html, setHtml] = useState('');
  useEffect(() => {
    const ele = document.getElementById('vditor-readonly') as HTMLDivElement;
    VditorPreview.preview(ele, content, {
      speech: {
        enable: true
      },
      hljs: {
        style: 'monokai'
      },
      transform: (html: string) => {
        return xss(html);
      },
      markdown: {
        codeBlockPreview: true,
        setext: true,
        toc: false
      },
      math: { inlineDigit: false, macros: {}, engine: 'KaTeX' }
    });
  }, [content]);

  useEffect(() => {
    VditorPreview.md2html(xss(content))
      .then((res: string) => {
        setHtml(res);
        return null;
      })
      .catch((err: string) => {
        return err;
      });
  }, [content]);

  const titClick = (index: number) => {
    const { current: editDom } = editCon;
    if (editDom) {
      const target = editDom.querySelectorAll('h1,h2,h3')[index];
      target.scrollIntoView({
        block: 'center'
      });
    }
  };

  return (
    <div className="common-presenter k-common-read-vditor">
      <div id="vditor-readonly" ref={editCon} />
      {<SFCCatelog val={html} itemClick={titClick} />}
    </div>
  );
}

export default SFCReadVditor;
